<template>
  <div @click="calendarModal = true" class="period">
    {{ displayDate }}
    <img src="@/assets/images/icons/calendar.svg" alt="calendar" />
    <DateRangePicker
        v-if="calendarModal"
        v-model="dateRange"
        :show="calendarModal"
        @updateShow="updateShow"
        @click-outside="calendarModal = false"
    />
  </div>
</template>

<script setup>
import moment from "moment";
import { onMounted, ref, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

moment.locale("ru");

const formatDate = "YYYY-MM-DD";

const props = defineProps({
  modelValue: Object,
  queryParam: {
    type: String,
    default: "period",
  },
});

const emit = defineEmits(["update:modelValue"]);

const calendarModal = ref(false);
const updateShow = (arg) => (calendarModal.value = arg);

const dateRange = ref({ start: null, end: null });

const route = useRoute();
const router = useRouter();

// Формат отображения даты
const displayDate = computed(() => {
  const start = dateRange.value?.start;
  const end = dateRange.value?.end;

  if (!start || !end) return "";

  const format = (date) => {
    const day = date.getDate();
    const month = date.toLocaleString('ru-RU', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  return `${format(start)} - ${format(end)}`;
});

// Чтение из query при инициализации
onMounted(() => {
  const param = route.query[props.queryParam];

  if (param) {
    // Если есть параметры в URL
    const [startStr, endStr] = param.split(",");
    dateRange.value = {
      start: moment(startStr, formatDate).toDate(),
      end: moment(endStr, formatDate).toDate(),
    };
    emit("update:modelValue", {
      start: moment(dateRange.value.start).format(formatDate),
      end: moment(dateRange.value.end).format(formatDate),
    });
  } else {
    // Установка даты прошлой недели по умолчанию
    const today = moment();
    const startOfLastWeek = today.clone().subtract(1, 'weeks').startOf('week');
    const endOfLastWeek = today.clone().subtract(1, 'weeks').endOf('week');

    dateRange.value = {
      start: startOfLastWeek.toDate(),
      end: endOfLastWeek.toDate(),
    };

    emit("update:modelValue", {
      start: startOfLastWeek.format(formatDate),
      end: endOfLastWeek.format(formatDate),
    });

    updateQueryFromRange(); // записываем в URL
  }
});

// Обновление query при изменении диапазона
watch(
    () => dateRange.value,
    () => {
      if (!dateRange.value?.start || !dateRange.value?.end) return;
      emit("update:modelValue", {
        start: moment(dateRange.value.start).format(formatDate),
        end: moment(dateRange.value.end).format(formatDate),
      });
      updateQueryFromRange();
    },
    { deep: true }
);

// Обновление query строки
function updateQueryFromRange() {
  const query = { ...route.query };
  query[props.queryParam] = `${moment(dateRange.value.start).format(formatDate)},${moment(dateRange.value.end).format(formatDate)}`;
  router.replace({ query });
}
</script>

<style lang="scss" scoped>
.period {
  position: relative;
  cursor: pointer;
}
</style>
